/**
 * Aventross AGM (Audited) chatflow (CAV001). title → 회사 선택 → confirm.
 *   steps/handleEvent 는 aura agm 플로우 재사용(Singapura 와 같은 방식). id·taskCode·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../../aura/agm/chatflows/auraAgmFlow';

export const aventrossAgmAuditedFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'aventross-agm-audited',
  taskCodeMatch: ['CAV001'],
  categoryMatch: ['aventross', 'agm', 'annual general meeting', 'audited'],

  getInitialMessages(_preSet: PreSetSelection): ConversationMessage[] {
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Aventross — AGM (Audited Companies)**.\n\n` +
          `This preset prepares the full AGM set in one document: Directors' Resolutions in Writing, Notice of AGM, ` +
          `Agreement to Shorter Notice, Minutes, Attendance, Disclosure of Interests (per director), Declaration, ` +
          `Notice to Registrable Controllers, Minutes by Representative, and Annex A / B / C registers.\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
